import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';

const Confirmation = () => {
  return (
    <>
      <div style={{ padding: '40px', textAlign: 'center' }}>
          <h1 className='text'>Thank You!</h1>
          <p className='text'>Your inquiry has been sent successfully. We'll be in touch soon.</p>
          <div className="bottom-space"></div>
          <div className="back-button-container">
              <Link to="/inquire" className="back-button">
                  Send another inquiry
              </Link>
          </div>
      </div>
      <p className='bottom-space' />
      <Footer />
    </>
  );
};

export default Confirmation;
